import axios from 'axios';
import Cookies from 'js-cookie';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

export interface User {
  id: number;
  email: string;
  name: string;
  picture?: string;
  role: 'admin' | 'editor' | 'releaser' | 'viewer' | 'user';
  is_active: boolean;
}

class AuthService {
  private tokenKey = 'access_token';

  getToken(): string | undefined {
    return Cookies.get(this.tokenKey);
  }

  setToken(token: string): void {
    Cookies.set(this.tokenKey, token, { expires: 1 }); // 1 day
  }

  removeToken(): void {
    Cookies.remove(this.tokenKey);
  }

  async login(): Promise<string> {
    const response = await axios.get(`${API_BASE_URL}/auth/login`);
    return response.data.auth_url;
  }

  async getCurrentUser(): Promise<User | null> {
    const token = this.getToken();
    if (!token) {
      return null;
    }

    try {
      const response = await axios.get(`${API_BASE_URL}/auth/me`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      // Token이 유효하지 않으면 제거
      this.removeToken();
      return null;
    }
  }

  async logout(): Promise<void> {
    const token = this.getToken();
    if (token) {
      try {
        await axios.post(
          `${API_BASE_URL}/auth/logout`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } catch (error) {
        console.error('Logout error:', error);
      }
    }
    this.removeToken();
  }

  isAuthenticated(): boolean {
    return !!this.getToken();
  }
}

export default new AuthService();